import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import styles from './DietFilters.module.scss';

import { toggleDietFilter } from 'store/foods/actions';
import { getAllowedDiets } from 'store/foods/selectors';
import SwitchSetting from 'components/SwitchSetting';
import { useTranslation } from 'features/translator';

const DietFilters = ({ filter }: { filter?: 'standard' | 'climate' }) => {
  const dispatch = useDispatch();
  const translation = useTranslation();
  const allowedDiets = useSelector(getAllowedDiets);

  const DIETS = {
    VL: translation.get('foodsPage', 'lowLactose'),
    L: translation.get('foodsPage', 'lactoseFree'),
    M: translation.get('foodsPage', 'milkFree'),
    G: translation.get('foodsPage', 'glutenFree'),
    Veg: translation.get('foodsPage', 'vegan'),
    Ilmastovalinta: translation.get('foodsPage', 'lowCarbonFootprint'),
  };

  const entries = Object.entries(DIETS).filter(([key]) => {
    if (filter === 'climate') return key === 'Ilmastovalinta';
    if (filter === 'standard') return key !== 'Ilmastovalinta';
    return true;
  });

  return (
    <div className={styles.component}>
      {entries.map(([key, value]) => (
        <SwitchSetting
          key={key}
          title={key === 'Ilmastovalinta' ? value : `${value} (${key})`}
          isActive={allowedDiets.includes(key)}
          clickHandler={() => dispatch(toggleDietFilter(key))}
        />
      ))}
    </div>
  );
};

export default DietFilters;
